import Purchase from '@/pages/Purchase'

// export default {
//   path: '/purchase',
//   name: 'purchase',
//   component: Purchase
// }

export default {
  path: '/purchase',
  component: Purchase,
  children: [
    {
      path: '',
      name: 'Purchase',
      component: Purchase,
    },
    {
      path: ':ref',
      name: 'RefPurchase',
      component: Purchase,
    },
  ]
}



// WEBPACK FOOTER //
// ./src/router/purchase.js